export function initBasicScripts() {
    
    // TODO Refactor all this shit
    
    $('body').on('touchmove', (e) => {
        if (!$('#site-header').has($(e.target)).length) {
        }
    })
    
    //SLICK slider
    // $('.slider').slick({
    //   arrows : true,
    //   prevArrow : '<div type="button" class="slick-prev"><i class="fa fa-chevron-left fa-5x"
    // aria-hidden="true"></i></div>', nextArrow : '<div type="button" class="slick-next"><i class="fa fa-chevron-right
    // fa-5x" aria-hidden="true"></i></div>', });
    $('.striped-slider').slick({
        arrows: false,
        autoplay: true,
    })
    
    
    // var footer = $("#site-footer");
    // var main = $("#main-content");
    //
    // main.css("margin-bottom", footer.height());
    //
    // function normalizeFooter() {
    //   window.innerWidth <= 900 ? main.css("margin-bottom", "") : main.css("margin-bottom", footer.height());
    // }
    // normalizeFooter();
    
    var mainContent = $('.main-content'),
        footer = $('#site-footer')
    
    function minMainHeight() {
        mainContent.css('min-height', window.innerHeight - footer.height() + 'px')
    }
    
    minMainHeight()
    
    
    var timeline = $('.timeline.do-vertical')
    
    function timelineToggler() {
        if (timeline) {
            window.innerWidth <= 900
            ? timeline.addClass('vertical').removeClass('horizontal')
            : timeline.addClass('horizontal').removeClass('vertical')
        }
    }
    
    timelineToggler()
    
    $(window).on('resize', function() {
        // normalizeFooter();
        timelineToggler()
        minMainHeight()
    })
    
    
    $('form input[type=\'file\']').on('change', event => {
        let p = $(event.target).closest('p'),
            val = /([\\/])?([^\\/]+$)/i.exec(event.target.value)[2]
        p.find('.filename').remove()
        p.append(`<span class="filename">${val}</span>`)
    })
}
